export const classes = {
  auroraButton:
    'size-8 rounded-[9px] text-taupe-3 transition-colors hover:bg-black/[0.06] hover:text-taupe-3 dark:text-mauve-2 dark:hover:bg-white/[0.06] dark:hover:text-mauve-1',
};
